import React from 'react';

const C = { logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)', triGrad:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)' };

export default function UserAvatar({ url, name, size=40, borderGrad=false }) {
  const initial = name ? name.charAt(0).toUpperCase() : '?';

  if (url) {
    return (
      <div style={{
        width:size, height:size, borderRadius:'50%', flexShrink:0, overflow:'hidden',
        background: borderGrad ? C.triGrad : 'transparent',
        padding: borderGrad ? 3 : 0,
      }}>
        <img src={url} alt={name||''} style={{
          width:'100%', height:'100%', borderRadius:'50%', objectFit:'cover',
          display:'block',
        }}/>
      </div>
    );
  }

  return (
    <div style={{
      width:size, height:size, borderRadius:'50%',
      background: C.logoGrad,
      display:'flex', alignItems:'center', justifyContent:'center',
      color:'#fff', fontSize:size*0.4, fontWeight:700, flexShrink:0,
    }}>{initial}</div>
  );
}
